define("Magento_Ui/js/core/app",["./renderer/types","./renderer/layout","../lib/knockout/bootstrap"],function(e,t){"use strict";return function(n,o){e.set(n.types),t(n.components,void 0,!0,o)}});
